import { breakpointUp } from './utils/breakpoints'
import { waitForLocoScrollUpdate } from './locomotive-scroll'

function setupRankingActions(locoScroll)
{

  const target = document.querySelector('#page-content')
  let rankingsGrid = '#rankings-grid'
  let jsScrollLink = '.js-ranking-loco-scroll'

  $(rankingsGrid).attr('data-post-loading', 0)

  $('body').on('click', jsScrollLink, function (e){

    $(rankingsGrid).attr('data-post-loading', 1)
    waitForLocoScrollUpdate(rankingsGrid)
    if(breakpointUp('lg')) {
      locoScroll.scrollTo(target, { offset: -100})
    } else {
      $("html, body").animate({scrollTop: 200}, 400);
    }
  })
}

let $pageRankings = $('.page-rankings')
if($pageRankings.length) {
  let colorAttr = $pageRankings.attr('data-rank-color')
  $('footer, .sticky-back-button').attr('data-rank-color', colorAttr)
}

export { setupRankingActions }
